// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".live-position[data-v-6d9ab45e]{position:absolute !important;top:0;left:50%;transform:translate(-50%, -50%);z-index:1}.live-position.label-left[data-v-6d9ab45e]{top:-3px;left:10px;transform:translate(0, -50%)}.super-live-position[data-v-6d9ab45e]{border:1px solid var(--v-superBlue-base) !important;background:var(--v-superBlue-base) !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
